import styles from './SiteFooter.module.scss';

export function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <span>© Alpantos Academy</span>
      <span>
        Need help? <a href="mailto:learn@alpantos.com">learn@alpantos.com</a>
      </span>
    </footer>
  );
}
